module.exports = __webpack_public_path__ + "static/media/home-white.9948ff8c.gif";